<template>
    <div id="favorite-shop-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Booking Addresses</h2>
            <div class="mt--2 heading-small">Locations used for searching shops</div>
        </div>

        <div class="bg-white shadow-reg list-container">
            <div class="header text-right">
                <button class="btn bg-white text-danger" @click="showCreateForm">
                    <i class="fa fa-plus mr-2"></i> Add Address
                </button>
            </div>
            <booking-address-create-form ref="createForm" @created="addressCreated" />
            <booking-address-form ref="updateForm" @updated="addressCreated" />
            <div class="list-wrapper">
                <paginated-section :fetch-link="addressFetchLink" paginate-path="data.result.addresses" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading addresses
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No addresses were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <booking-address-list-item :address="record" @deleted="addressRemoved" @update="updateAddress" />
                    </template>
                </paginated-section>
            </div>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import mixins from "@utils/mixins";
import BookingAddressListItem from "./BookingAddressListItem";
import BookingAddressCreateForm from "./BookingAddressCreateForm";
import BookingAddressForm from "./BookingAddressForm";
import { route, get } from "@utils/network";

export default {
    name: "BookingAddressesListPage",

    components: { BookingAddressListItem, BookingAddressCreateForm, BookingAddressForm },

    computed: {
        addressFetchLink() {
            return route("shop-search-addresses");
        },
    },

    data: () => ({
        loading: false,
        addresses: [],
    }),

    methods: {
        addressRemoved() {
            this.$refs.list.refresh();
        },
        showCreateForm() {
            this.$refs.createForm.show();
        },
        addressCreated() {
            this.$refs.list.refresh();
        },
        updateAddress(address) {
            this.$refs.updateForm.show(address);
        }
    },

    mixins: [mixins],

    mounted() {
        this.$emit("mounted");
    }
}
</script>
<style lang="css" scoped>
    .list-container .list-content-item {
        margin-bottom: 0.5rem !important;
        padding: 2rem 1.5rem 2rem !important;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
</style>